import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DescriptionReduite } from '../models/DescriptionReduite';
@Component({
  selector: 'app-description-reduite',
  templateUrl: './description-reduite.component.html'
})
export class DescriptionReduiteComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'DescriptionReduite'
  @Input() parentForm: FormGroup;
  	@Input() descriptionReduite : DescriptionReduite;

  constructor() { }

  public ngOnInit() {
  }








  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

